import {ReactElement} from "react";
import type { ArticleData } from "../../../wiki/types/ArticleData";
import type { DrawerProps } from "../../../../common/components/layout/Drawer/Drawer";
import Cookies from "universal-cookie";

import Drawer from "../../../../common/components/layout/Drawer/Drawer";

import { useGetArticle } from "../../../../net/ArticleManagement";
import {useEffect, useState} from "react";
import WikiArticleDisplayPanel from "../../../wiki/components/WikiArticleDisplayPanel";
import Spinner from "../../../../common/components/system/Spinner/Spinner";

const blankArticle: ArticleData = {
    id: -1,
    title: "",
    text: "",
    categories: [],
    creator: null,
    editor: null,
    properties: [],
    isWhitelistProtected: false,
    whitelist: { viewers: [], editors: [] },
};

type Props = Readonly<DrawerProps & {
    articleID?: number,
    articleTitle?: string,
}>;

export default function WikiArticleDrawer({alignment = "right", isVisible, width, height, onClose, showCloseButton = true, articleID, articleTitle}: Props): ReactElement {
    const [loadArticle, isLoadingArticle] = useGetArticle();
    const [articleData, setArticleData] = useState<ArticleData>(blankArticle);
    const cookies = new Cookies();

    useEffect(() => {
        loadArticle({
            variables: {
                identifier: {
                    id: articleID ?? undefined,
                    article: articleTitle ?? undefined,
                },
                token: cookies.get("session_token") ?? undefined,
                format: 1,
            },
            onComplete: (result) => {
                if (result != null) {
                    setArticleData({
                        id: result.id ?? -1,
                        title: result.title ?? "",
                        text: result.description ?? "",
                        categories: result.categories ?? [],
                        creator: result.creator
                            ? {
                                  id: result.creator.id ?? -1,
                                  name: result.creator.display_name ?? "",
                              }
                            : null,
                        editor: result.editor
                            ? {
                                  id: result.editor.id ?? -1,
                                  name: result.editor.display_name ?? "",
                              }
                            : null,
                        properties: result.properties ?? [],
                        isWhitelistProtected:
                            result.whitelist_protected ?? true,
                        whitelist: {
                            viewers: result.whitelist?.readers ?? [],
                            editors: result.whitelist?.writers ?? [],
                        },
                    });
                }
            },
            onError: (err) => {
                console.error("Failed to load article: ", articleID ?? articleTitle ?? "Unknown");
                setArticleData(blankArticle);
            },
        });
    }, [articleID, articleTitle]);

    return (
        <Drawer alignment={alignment} isVisible={isVisible} width={width} height={height} onClose={onClose} showCloseButton={showCloseButton}>
            {isLoadingArticle() ? 
                <Spinner /> :
                <WikiArticleDisplayPanel article={articleData} showCategories={false} showAttributions={false} />
            } 
        </Drawer>
        );
}